import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { is_enabled_module } from '@/Composable/usePermission'

export const useCountryStore = defineStore('countries', () => {
    const countries = ref([])
    const states = ref([])
    const cities = ref([])
    const districts = ref([])
    const LoadingCountry = ref(false);
    const LoadingState = ref(false);
    const LoadingCity = ref(false);
    const LoadingDistrict = ref(false);

    const getCountries = computed(() => countries.value)



    function getIndex(country) {
        const index = countries.value.findIndex(object => {
            return object.id === user.id;
        });
        return index;

    }
    async function fetchCountries() {
        if (!is_enabled_module('country')) {
            countries.value = [];
            return;
        }
        LoadingCountry.value = true;
        await axios.get(route('api.countries')).then(res => {
            countries.value = res.data;
        })
        LoadingCountry.value = false;
    }
    async function fetchState(country_id) {
        if (country_id == null || country_id == '') {
            states.value = [];
            return;
        }
        LoadingState.value = true;
        await axios.get(route('api.statesByCountry', country_id)).then(res => {
            states.value = res.data;
        })
        LoadingState.value = false;
    }
    async function fetchCities(state_id) {
        LoadingCity.value = true;
        await axios.get(route('api.getCitiesByState', state_id)).then(res => {
            cities.value = res.data;
        })
        LoadingCity.value = false;
    }
    async function fetchDistricts(city_id) {
        LoadingDistrict.value = true;
        await axios.get(route('api.getDistrictsByCity', city_id)).then(res => {
            districts.value = res.data;
        })
        LoadingDistrict.value = false;
    }
    function updateCountry(country) {
        let index = getIndex(country);
        if (index != -1) {
            countries.value[index] = country;
        } else {
            countries.value.push(country);
        }

    }
    async function FindCountryByState(state_id) {
        let stateaaa = {};
        await window.axios.get(route('api.stateById', state_id)).then(res => {
            stateaaa = res.data;

        })

        if (stateaaa) {
            return stateaaa.country_id;
        }
        return null;
    }
    function addToCountries(countriesPlus) {

        countriesPlus.map((u, key) => {
            if (!countries.value.find(e => e.id == u.id)) {
                countries.value.push(u);
            }
            return true;
        })
    }
    function removeFromCountry(country) {

        countries.value.splice(getIndex(user), 1);

    }


    return {
        countries, states, cities, districts, getCountries, FindCountryByState, addToCountries, removeFromCountry, fetchCountries, fetchState, fetchCities, updateCountry,
        LoadingCountry,
        LoadingState,
        LoadingCity,
        LoadingDistrict,
        fetchDistricts
    }
})
